import { Component } from "react";

class Legend extends Component {
  constructor(props) {
    super(props);
    this.state = {}
  }
  render() {
    const classes = `rounded-full border border-white w-4 h-4 bg-${this.props.color}`
    return (
      <div className="flex items-center gap-2">
        <div className={classes}></div>
        <p className="text-white">{this.props.children}</p>
      </div>
    );
  }
}

export default Legend;